import { render, staticRenderFns } from "./WorkBench.vue?vue&type=template&id=a2254740&scoped=true"
import script from "./WorkBench.vue?vue&type=script&lang=js"
export * from "./WorkBench.vue?vue&type=script&lang=js"
import style0 from "./WorkBench.vue?vue&type=style&index=0&id=a2254740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2254740",
  null
  
)

export default component.exports